import React from 'react';
import { FormSpy } from 'react-final-form';

import EditToolbar from '../../core/components/edit/EditToolbar';
import TenantConfigurationSummary from './TenantConfigurationSummary';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const valideIntervals = (interval1, interval2) => {
  let isValid = true;
  if (interval1 && interval2) {
    const val1 = parseInt(interval1, 10);
    const val2 = parseInt(interval2, 10);
    const difference = Math.abs(val1 - val2);
    if (difference < 4 || difference > 20) {
      isValid = false;
    }
  }
  return isValid;
};

/**
 * Tenant Configuration form validation rules
 * @param {*} values Form values
 * @returns errors object
 */
const validateTenantConfiguration = values => {
  const errors = {};
  const intervalMessageError =
    'Minimum difference between two execution times must be at least 4h.';
  if (!valideIntervals(values.interval0, values.interval1)) {
    errors.interval1 = intervalMessageError;
  }
  if (!valideIntervals(values.interval1, values.interval2)) {
    errors.interval2 = intervalMessageError;
  }
  if (!valideIntervals(values.interval0, values.interval2)) {
    errors.interval2 = intervalMessageError;
  }
  return errors;
};

const TenantConfigurationForm = props => {
  const {
    hasCreate,
    hasList,
    hasEdit,
    hasShow,
    handleFormIsDirty,
    displayToolbar,
    ...rest
  } = props;

  const { record = {} } = props;
  const initialValues = {};
  if (record.type === 'TIME_T') {
    if (typeof record.value === 'string') {
      const parts = record.value.split(' ');
      if (parts.length === 2) {
        initialValues['time'] = parts[0];
        initialValues['zone'] = parts[1];
      }
    }
  } else if (record.type === 'TIME_M') {
    if (typeof record.value === 'string') {
      const parts = record.value.split('#');
      parts.forEach(
        (part, index) => (initialValues[`interval${index}`] = part)
      );
    }
  }

  return (
    <CustomSimpleForm
      initialValues={initialValues}
      toolbar={
        displayToolbar ? <EditToolbar {...rest} deletable={false} /> : <></>
      }
      variant="standard"
      margin="normal"
      validate={validateTenantConfiguration}
      {...rest}
    >
      <FormSpy subscription={{ pristine: true }}>
        {formprops => {
          return (
            <TenantConfigurationSummary
              {...props}
              formApi={formprops.form}
              creation={false}
              variant="standard"
            />
          );
        }}
      </FormSpy>
      <FormSpy
        subscription={{ dirty: true }}
        onChange={formProps => {
          handleFormIsDirty(formProps.dirty);
        }}
      />
    </CustomSimpleForm>
  );
};

export default TenantConfigurationForm;
